export function validatePasswordInt (password) {
  return /[0-9]/.test(password)
}

export function validatePasswordUppercase (password) {
  return /[A-Z]/.test(password)
}

export function validatePasswordLowercase (password) {
  return /[a-z]/.test(password)
}

export function validatePasswordLength (password) {
  return password.length >= 8
}

export function validatePasswordWhitespace (password) {
  return /^[^\s]+(\s+[^\s]+)*$/.test(password)
}

const validatePassword = (password) => validatePasswordLength(password) && validatePasswordLowercase(password) && validatePasswordUppercase(password) && validatePasswordInt(password) && validatePasswordWhitespace(password)
export default validatePassword
